"use strict";

var _classCallCheck = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonDrawerBase = void 0;

var PolygonDrawerBase =
/*#__PURE__*/
function () {
  function PolygonDrawerBase() {
    _classCallCheck(this, PolygonDrawerBase);
  }

  _createClass(PolygonDrawerBase, [{
    key: "draw",
    value: function draw(context, particle, radius) {
      var start = this.getCenter(particle, radius);
      var side = this.getSidesData(particle, radius);
      var sideCount = side.count.numerator * side.count.denominator;
      var decimalSides = side.count.numerator / side.count.denominator;
      var interiorAngleDegrees = 180 * (decimalSides - 2) / decimalSides;
      var interiorAngle = Math.PI - Math.PI * interiorAngleDegrees / 180;

      if (!context) {
        return;
      }

      context.beginPath();
      context.translate(start.x, start.y);
      context.moveTo(0, 0);

      for (var i = 0; i < sideCount; i++) {
        context.lineTo(side.length, 0);
        context.translate(side.length, 0);
        context.rotate(interiorAngle);
      }
    }
  }]);

  return PolygonDrawerBase;
}();

exports.PolygonDrawerBase = PolygonDrawerBase;